import localScaleManager from "../../../helpers/LocalScaleManager";

export default class MenuBtn extends Phaser.GameObjects.Image {
  /**
   * @param scene {GameScene}
   * @param texture {string}
   * @param number {number}
   */
  constructor(scene, texture, number) {
    super(scene, 0, 0, scene.atlasTexture, texture);
    this.scene = scene;
    this.mainTexture = texture;
    this.number = number;
    this.setInteractive({ cursor: "pointer" });
    // this.btn = this.scene.add.image(0, 0, this.scene.atlasTexture, this.texture).setInteractive({cursor: 'pointer'});
    // this.btn = this.scene.add.sprite(0, 0, this.texture).setInteractive({cursor: 'pointer'});
    this.scene.add.existing(this);

    this.on("pointermove", this.hoverBtn, this);
    this.on("pointerout", this.hoverOutBtn, this);

    this.setDepth(110);
    this.setOrigin(0);
    this.initX = 0;

    this.disabled = false;
  }
  hoverBtn() {
    if (!this.disabled) {
      this.setTint(0x2993cb);
    }
  }
  disable() {
    if (!this.disabled) {
      if (this.frame.name !== `${this.mainTexture}-d`)
        this.setFrame(`${this.mainTexture}-d`, false, false);
      this.disabled = true;
      this.disableInteractive();
    }
  }
  enable() {
    if (this.disabled) {
      if (this.frame.name !== `${this.mainTexture}`)
        this.setFrame(`${this.mainTexture}`, false, false);
      this.disabled = false;
      this.setInteractive();
    }
  }
  hoverOutBtn() {
    if (!this.disabled) {
      this.clearTint();
    }
  }
  /**
   * @param width {number} table
   * @param height {number} table
   * @param x {number}
   * @param y {number}
   */
  positionControls(width, height, x, y) {
    const size = width / 1.7;
    localScaleManager.scaleSprite(this, size, size, 0, 1, true);
    this.setPosition(x, y);
  }
  /**
   * @param width {number} table
   * @param height {number} table
   * @param x {number}
   * @param y {number}
   */
  reposition(width, height, x, y) {
    this.setPosition(x, y);
  }

  updatePositions(x) {
    // this.initX = initX;
    this.setX(x);
  }
}
